import React, { Component } from 'react';
import classNames from 'classnames';
import { SvgImage } from '.';
import { PinIconNew, pinIcon } from '../../style/images';
import { translate } from '../services';
import { PropTypes } from 'prop-types';
import { ProductLink } from './ProductLink';

const PinIcon = ( { item, onPin, pinned, tooltip } ) => {
  const onClick = () => onPin( item );

  return <SvgImage
    source={ PinIconNew }
    toolTip={ tooltip }
    className={ classNames( 'pin-icon', { 'pinned': pinned } ) }
    // eslint-disable-next-line react/jsx-no-bind
    onClick={ onClick }
    isMUTooltipRequired ={true}
  />;
};

const listboxKeyProvider = ( item ) => item.name || item.value;

export class ListBoxItem extends Component {
  selectorClicked = e => {
    const className = e.target.className;
    if ( typeof className !== 'string' || !className.includes( 'listbox-content' ) && !className.includes( 'list-box-item' ) ) {
      return;
    }

    this.props.onChange( this.props.item );
  }

  productLinkIcon = item => {
    const { isBomItem } = this.props;

    return !!isBomItem ? <ProductLink key={ 'productLink' } name={ item.name } title={ item.title } /> : null;
  }

  renderItem() {
    const { data, isPinned, isSelected, item, onItemPinned, pinnable, viewItem } = this.props;
    const Item = viewItem;
    const isPinnedItem = isPinned( item );
    const toolTip = translate( isPinnedItem
      ? 'Unpin this value. It won\'t be preselected anymore'
      : 'Pin this value for having it preselected the next times'
    );

    return !isSelected( item, data ) || !pinnable
      ? [
        <Item key={ listboxKeyProvider( item ) } { ...item } />,
        this.productLinkIcon( item )
      ]
      : [
        <Item key={ listboxKeyProvider( item ) } { ...item } />,
        <PinIcon key="svg" item={ item } tooltip={ toolTip } pinned={ isPinnedItem } onPin={ onItemPinned } />
      ];
  }

  render() {
    const { data, isDefault, isForceable, isSelected, item } = this.props;
    const className = classNames( 'list-box-item', { 'default': isDefault( item, data ), 'selected': isSelected( item, data ), 'forceable': isForceable( item, data ) } );
    return <div onClick={ this.selectorClicked } className={ className }>
      { this.renderItem() }
    </div>;
  }
}

ListBoxItem.propTypes = {
  data: PropTypes.arrayOf( PropTypes.object ).isRequired,
  isPinned: PropTypes.func,
  isDefault: PropTypes.func,
  isSelected: PropTypes.func,
  item: PropTypes.shape( {} ).isRequired,
  onChange: PropTypes.func.isRequired,
  onItemPinned: PropTypes.func.isRequired,
  pinnable: PropTypes.bool,
  viewItem: PropTypes.oneOfType( [PropTypes.node, PropTypes.func, PropTypes.elementType] ).isRequired,
  isBomItem: PropTypes.bool
};